module.exports = __webpack_public_path__ + "img/ico-recipient-download.692ba47b.svg";